export default "__VITE_ASSET__CLT1wZRX__"